import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/pages/explore/ExploreFederationsPageClient.tsx");
